import { apiPost, apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';

function isLandlordApp() {
  return window.location.pathname.startsWith('/companies/');
}

export function saveApplicantSubmissionProgress({ blocks, applicationId, cotenantId }) {
  return apiPost(`${Auth.getApiUrl()}/leads/applicant_submissions/save_progress`, {
    blocks,
    is_landlord_app: isLandlordApp(),
    cotenant_id: cotenantId,
    application_id: applicationId,
  });
}

export function submitApplicantSubmission({ applicationId, cotenantId, ...data }) {
  return apiPost(`${Auth.getApiUrl()}/leads/applicant_submissions/submit`, {
    ...data,
    is_landlord_app: isLandlordApp(),
    cotenant_id: cotenantId,
    application_id: applicationId,
  });
}

export function getApplicantSubmission(applicationId, cotenantId) {
  return apiGet(
    `${Auth.getApiUrl()}/leads/applicant_submissions?cotenant_id=${cotenantId}&application_id=${applicationId}&is_landlord_app=${isLandlordApp()}`
  );
}
